var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collapseBtn",style:({
          width: _vm.isCollapse ? '64px' : '200px',
          height: _vm.isCollapse ? '40px' : '40px'
      })},[_c('el-button',{staticClass:"btn",attrs:{"icon":_vm.isCollapse ? 'el-icon-arrow-right' : 'el-icon-arrow-left'},on:{"click":_vm.handleChangeCollapse}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }